import { Component, OnInit, Inject, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { CarteraService } from 'app/services/cartera/cartera.service';

@Component({
  selector: 'app-facturas-atrasadas',
  templateUrl: './facturas-atrasadas.component.html',
  styleUrls: ['./facturas-atrasadas.component.scss']
})
export class FacturasAtrasadasComponent implements OnInit {

  // Variables DataTable //
  public dtOptions = [];
  public table_cantFacturasAtr: Array<any> = [];
  public table_facturasAtr = [];
  @ViewChild(DataTableDirective , {static: true}) table: DataTableDirective;

  public show_table: Boolean;

  /**
   * Constructor
   * 
   * @param _data 
   * @param {CarteraService} _cartera 
   */
  constructor(@Inject(MAT_DIALOG_DATA) private _data, private _cartera: CarteraService) {
    this.show_table = false;

    this.dtOptions[0] = {
      language: {
        sProcessing: "Procesando...",
        sLengthMenu: "Mostrar _MENU_ registros",
        sZeroRecords: "No se encontraron resultados",
        sEmptyTable: "Ningún dato disponible en esta tabla",
        sInfo: "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
        sInfoEmpty: "Mostrando registros del 0 al 0 de un total de 0 registros",
        sInfoFiltered: "(filtrado de un total de _MAX_ registros)",
        sInfoPostFix: "",
        sSearch: "Buscar:",
        sUrl: "",
        sInfoThousands: ",",
        sLoadingRecords: "Cargando...",
        oPaginate: {
          sFirst: "Primero",
          sLast: "Último",
          sNext: "Siguiente",
          sPrevious: "Anterior"
        }
      },
      columns: [
        {
          title: 'Documento',
          data: 'grunit'
        },
        {
          title: 'Radicado',
          data: 'grugru',
        },
        {
          title: 'Nombre',
          data: 'grunom'
        },
        {
          title: 'N° Facturas Atrasadas',
          data: 'cant_atraso'
        }
      ]
    };

    this.dtOptions[1] = {
      scrollY: '385px',
      language: {
        sEmptyTable: "Ningún dato disponible en esta tabla",
        sInfo: "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
        sInfoEmpty: "Mostrando registros del 0 al 0 de un total de 0 registros",
        sInfoFiltered: "(filtrado de un total de _MAX_ registros)",
        sInfoPostFix: "",
        sSearch: "Buscar:",
        sUrl: "",
        sInfoThousands: ",",
        sLoadingRecords: "Cargando...",
        oPaginate: {
          sFirst: "Primero",
          sLast: "Último",
          sNext: "Siguiente",
          sPrevious: "Anterior"
        }
      },
      order: [0, 'desc'],
      columns: [
        {
          title: 'Fecha',
          data: 'fecha'
        },
        {
          title: 'N° Factura',
          data: 'n_factura'
        },
        {
          title: 'Nombre',
          data: 'nombre_factura'
        },
        {
          title: 'Valor Unitario',
          data: 'valor_u'
        },
        {
          title: 'Valor Total',
          data: 'valor_t'
        },
        {
          title: 'Saldo Anterior',
          data: 'saldo_ant'
        },
        {
          title: 'Nuevo Saldo',
          data: 'nvo_saldo'
        }
      ]
    }

    this.table_cantFacturasAtr.push(_data.info_grupo);
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On Init
   */
  ngOnInit() {
    this._cartera.VerFacturasAtrasadas(this._data.base_datos, this._data.info_grupo.grunit, this._data.info_grupo.grugru).subscribe((data: any) => {
      this.table_facturasAtr = data;
    });
  }
}
